import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchModal from '../components/SearchModal';
import ChatBot from '../components/ChatBot';
import HomeSampleSection from '../components/HomeSampleSection';


function Home() {
  const navigate = useNavigate();

  // State to control the Search Modal visibility
  const [showSearch, setShowSearch] = useState(false);

  // Ref to control the ChatBot
  const chatBotRef = useRef(null);

  // JavaScript for the news carousel
  const scrollNewsCarousel = (direction) => {
    const container = document.getElementById("news-carousel");
    const scrollAmount = 300;
    if (container) {
      container.scrollBy({ left: scrollAmount * direction, behavior: "smooth" });
    }
  };

  // Helper style for clickable cards
  const pointerStyle = { cursor: 'pointer' };

  return (
    <>
      {/* --- HERO SECTION START --- */}
      <div className="container text-white py-4 my-5" style={{
        background: 'linear-gradient(90deg, rgb(65 47 128) 0%, rgb(40, 37, 97) 100%)',
        overflow: 'hidden',
        borderRadius: '2rem'
      }}>
        <div className="container">
          {/* <button>Get Discount card</button> */}
          <div className="row align-items-center">

            {/* 1. Left Side: Text and Search Button */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <h2 className="display-4 fw-bold mb-4" style={{ lineHeight: '1.1', fontSize: '2.5rem' }}>
                Find and Book the Best Doctor near You
              </h2>
              <span className="badge-custom">
                <input type="checkbox" defaultChecked className="form-check-input me-1" /> 9M+ tele-consultations
              </span>

              {/* Search Button */}
              <div
                className="input-group mt-4 mb-2"
                onClick={() => setShowSearch(true)}
                style={{ cursor: 'pointer' }}
              >
                <input
                  type="text"
                  className="form-control"
                  placeholder="Skardu, Doctor, Hospital, Condition"
                  style={{ outline: 'none', boxShadow: 'none', backgroundColor: 'white' }}
                  readOnly
                />
                <button
                  className="btn btn-search"
                  style={{ outline: 'none', boxShadow: 'none', fontSize: '20px', backgroundColor: '#f6ad35' }}
                >
                  Search
                </button>
              </div>
            </div>

            {/* 2. Right Side: The Embedded Chatbot */}
            <div className="col-lg-7">
              <div style={{ height: '500px', width: '100%' }}>
                <ChatBot embedded={true} />
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* --- HERO SECTION END --- */}

      {/* --- 3. Service Cards (4-Box) --- */}
      <div className="container my-5">
        <div className="row g-4">

          {/* In-Clinic Appointments -> Opens Search Modal */}
          <div className="col-md-3 col-sm-6">
            <div className="service-card" onClick={() => setShowSearch(true)} style={pointerStyle}>
              <img src="/images/a.jpeg" alt="In-Clinic Appointments" />
              <h5>In-Clinic Appointments</h5>
              <p className="fs-5">Book an In-Person visit to doctor's clinic.</p>
            </div>
          </div>

          {/* Laboratory Tests -> Goes to Labs Page */}
          <div className="col-md-3 col-sm-6">
            <div className="service-card" onClick={() => navigate('/labs/skardu')} style={pointerStyle}>
              <img src="/images/laboratory.jpeg" alt="Laboratory Tests" />
              <h5>Laboratory Tests</h5>
              <p className="fs-5">Avail exclusive discounts on lab tests.</p>
            </div>
          </div>

          {/* Procedures -> Goes to Surgeries Page */}
          <div className="col-md-3 col-sm-6">
            <div className="service-card" onClick={() => navigate('/surgeries')} style={pointerStyle}>
              <img src="/images/procedure.jpeg" alt="Procedures & Surgeries" />
              <h5>Procedures & Surgeries</h5>
              <p className="fs-5">Plan your surgeries at discounted rates.</p>
            </div>
          </div>

          {/* Medical Treatment -> Goes to Hospitals Page */}
          <div className="col-md-3 col-sm-6">
            <div className="service-card" onClick={() => navigate('/hospitals/skardu')} style={pointerStyle}>
              <img src="/images/medicine.jpeg" alt="Medicines" />
              <h5>Medical treatment</h5>
              <p className="fs-5">Care provided to heal illness and restore health.</p>
            </div>
          </div>
        </div>
      </div>

      {/* --- Haleon Oral Health Care --- */}
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-6 mt-4 mb-4 p-3"
            style={{ height: 'auto', boxShadow: '2px 4px 10px rgba(0, 0, 0, 0.3)', textAlign: 'center', backgroundColor: '#F0FDFF', justifyContent: 'center', alignItems: 'center' }}>
            <h2 className="mt-4">Haleon Oral Health Care</h2>
            <img src="/images/sensodyne.webp" alt="" style={{ width: '100px' }} />
            <p className="fs-4">Your ultimate guide to oral health.</p>
          </div>
          <div className="col-md-6 lg-6 mt-4 mb-4 p-3"
            style={{ height: 'auto', boxShadow: '2px 4px 10px rgba(0, 0, 0, 0.3)', textAlign: 'center', backgroundColor: '#FFE5F2' }}>
            <h2 className="mt-4">BOLO Health for Youth</h2>
            <img src="/images/health.jpg" alt="" style={{ width: '100px' }} />
            <p className="fs-4">Family planning & reproductive health services</p>
          </div>
        </div>
      </div>

      {/* --- Consult Best Doctors Online --- */}
      <div className="container my-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3>Consult best doctors online</h3>
          <a href="/doctors" className="view-all text-decoration-underline text-primary">View All</a>
        </div>
        <div className="row text-center g-4">
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/dermatologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/skin-specialist.png" alt="Dermatologist" width="50" />
            </div>
            <div className="specialist-text">Dermatologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/gynecologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/gynecologist.png" alt="Gynecologist" width="50" />
            </div>
            <div className="specialist-text">Gynecologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/urologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/urologist.png" alt="Urologist" width="50" />
            </div>
            <div className="specialist-text">Urologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/gastroenterologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/gastroenterologist.png" alt="Gastroenterologist" width="50" />
            </div>
            <div className="specialist-text">Gastroenterologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/dentist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/dentist.png" alt="Dentist" width="50" />
            </div>
            <div className="specialist-text">Dentist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/psychiatrist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/psychiatrist.png" alt="Psychiatrist" width="50" />
            </div>
            <div className="specialist-text">Psychiatrist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/orthopedic-surgeon')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/orthopedic-surgeon.png" alt="Orthopedic Surgeon" width="50" />
            </div>
            <div className="specialist-text">Orthopedic<br />Surgeon</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/sexologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/sexologist.jpeg" alt="Sexologist" width="50" />
            </div>
            <div className="specialist-text">Sexologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/neurologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/neurologist.png" alt="Neurologist" width="50" />
            </div>
            <div className="specialist-text">Neurologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/child-specialist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/child-specialist.png" alt="Child Specialist" width="50" />
            </div>
            <div className="specialist-text">Child<br />Specialist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/pulmonologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/general-physician.png" alt="Pulmonologist" width="50" />
            </div>
            <div className="specialist-text">Pulmonologist</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/eye-specialist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/eye-specialist.png" alt="Eye Specialist" width="50" />
            </div>
            <div className="specialist-text">Eye Specialist</div>
          </div>
        </div>
      </div>

      {/* --- Search Doctor by Condition --- */}
      <div className="container my-5 mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3>Search Doctor by Condition</h3>
          <a href="#" className="view-all text-decoration-underline text-primary">View All</a>
        </div>
        <div className="row text-center g-4">
          <div className="col-6 col-sm-4 col-md-3 col-lg-2 " onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/fever.png" alt="Fever" width="50" />
            </div>
            <div className="specialist-text">Fever</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/cardiology')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/heart-attack.png" alt="Heart Attack" width="50" />
            </div>
            <div className="specialist-text">Heart Attack</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/gynecologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/pregnancy.png" alt="Pregnancy" width="50" />
            </div>
            <div className="specialist-text">Pregnancy</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/high-blood-pressure.png" alt="High Blood Pressure" width="50" />
            </div>
            <div className="specialist-text">High Blood Pressure</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/gastroenterologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/piles.png" alt="Piles" width="50" />
            </div>
            <div className="specialist-text">Piles</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/gastroenterologist')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/diarrhea.png" alt="Diarrhea" width="50" />
            </div>
            <div className="specialist-text">Diarrhea</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/typhid.jpeg" alt="Typhoid Fever" width="50" />
            </div>
            <div className="specialist-text">Typhoid Fever</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/dengue_fever.jpeg" alt="Dengue Fever" width="50" />
            </div>
            <div className="specialist-text">Dengue Fever</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/malaria.png" alt="Malaria" width="50" />
            </div>
            <div className="specialist-text">Malaria</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/yellow_fever.png" alt="Yellow Fever" width="50" />
            </div>
            <div className="specialist-text">Yellow Fever</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/viral_fever.png" alt="Viral Fever" width="50" />
            </div>
            <div className="specialist-text">Viral Fever</div>
          </div>
          <div className="col-6 col-sm-4 col-md-3 col-lg-2" onClick={() => navigate('/specialty/general-physician')} style={pointerStyle}>
            <div className="specialist-icon">
              <img src="/images/icons/rehumatic_fever.png" alt="Rheumatic Fever" width="50" />
            </div>
            <div className="specialist-text">Rheumatic Fever</div>
          </div>
        </div>
      </div>

      {/* --- Our Esteemed Partners --- */}
      <div className="container">
        <div className="row">
          <div className="col-md-12 lg-12">
            <div className="our_esteem_div p-4 mb-4" style={{ boxShadow: '2px 4px 10px rgba(0, 0, 0, 0.3)', textAlign: 'center' }}>
              <h2 className="our_esteem fw-bold mt-4 mb-4">Our Esteemed Partners</h2>
              <p className="our_esteem_p fs-4 mb-4 mt-4 " style={{ marginBottom: '30px' }}>Avail Exclusive partnership benefits for
                your brand, clients and employees.</p>
              <div>
                <a href="#" className="ddoctor_btn mt-4 mb-4 fs-4 p-3"
                  style={{ display: 'inline-block', marginTop: '20px', padding: '10px', boxShadow: '2px 4px 10px rgba(0, 0, 0, 0.3)', borderRadius: '10px', textAlign: 'center', backgroundColor: '#08009B', color: 'white', fontWeight: 'bold', textDecoration: 'none' }}>Partner
                  with D.Doctor</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Carousel Partner 1 --- */}
      <div className="container py-5">
        <div id="logoCarousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="row row-cols-2 row-cols-md-4 g-4">
                <div className="col"><div className="logo-card"><img src="/images/carousel1/alfalah.webp" alt="Bank Alfalah" /></div></div>
                <div className="col"><div className="logo-card"><img src="/images/carousel1/beiersdorf.webp" alt="Beiersdorf" /></div></div>
                <div className="col"><div className="logo-card"><img src="/images/carousel1/blink.webp" alt="Shell" /></div></div>
                <div className="col"><div className="logo-card"><img src="/images/carousel1/cap.webp" alt="Chakor" /></div></div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="row row-cols-2 row-cols-md-4 g-5">
                <div className="col"><div className="logo-card"><img src="/images/carousel1/jazz.webp" alt="Jazz" /></div></div>
                <div className="col"><div className="logo-card"><img src="/images/carousel1/sybrid.webp" alt="Sybrid" /></div></div>
                <div className="col"><div className="logo-card"><img src="/images/carousel1/tcs.webp" alt="TCS" /></div></div>
                <div className="col"><div className="logo-card"><img src="/images/carousel1/zyonyks.webp" alt="Zyonyks" /></div></div>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#logoCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#logoCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <HomeSampleSection />

      {/* --- Carousel 2 (News) --- */}
      <div className="news-carousel-wrapper container">
        <h2 className="mt-4 mb-4">As seen in news</h2>
        <div className="news-arrow news-arrow-left" onClick={() => scrollNewsCarousel(-1)}>&#10094;</div>
        <div className="news-arrow news-arrow-right" onClick={() => scrollNewsCarousel(1)}>&#10095;</div>
        <div className="news-carousel-container" id="news-carousel">
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div className="news-card" key={item}>
              <img src="/images/carousel2/k2logo.png" alt="K2 Peak" />
              <div className="news-card-content">
                <strong>K2 Peak Technologies</strong>, Skardu, offers innovative IT solutions, web development, and consulting to help businesses succeed in the digital era.
                <br />
                <button className="btn btn-link p-0 text-decoration-none fw-bold news-read-more">
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* --- RENDER THE SEARCH MODAL --- */}
      {showSearch && <SearchModal onClose={() => setShowSearch(false)} />}
    </>
  );
}

export default Home;